import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatNum, momentFormat } from "@/utils/utils";
import { ISCMAssetsInventoryDetail } from "../assetsInventoryTypes";
import { useAssetsInventoryModel } from "../assetsInventoryModel";
import { globalPrompt } from "@/components/message";
import useNavModel from "@/model/navModel";
import { useAssetsInventoryDetailsModel } from "./details/assetsInventoryDetailsModel";
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { useOrgModel } from '@/views/base/organization/orgModel'

export function DataTable() {
    const { getTreeNodeName } = useDictModel(() => []);
    const { getSelectedDictOne } = useDictModel(() => [])
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys
    } = useAssetsInventoryModel();
    const { resetEditCatch } = useAssetsInventoryDetailsModel();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const { getOrgTreeSelect } = useOrgModel(() => []);

    useEffect(() => {
        loadData()
    }, [])
    const onLook = (value) => {

        let supplierEditKey = '3-1-3'
        let isFindNav = findNav(supplierEditKey)
        if (!isFindNav) {
            addNav(supplierEditKey, { id: value.id, mode: 'look' })
        } else {
            globalPrompt('modal', {
                title: '供应商跳转详情',
                type: 'warning',
                text: '您还有供应商详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: value.id, mode: 'look' })
                },
            })
        }
    }
    const columns: ColumnsType<ISCMAssetsInventoryDetail> = [
        {
            title: '序号',
            width: 50,
            align: "center",
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '盘点单号',
            width: 240,
            dataIndex: 'stocktakingCode',
            fixed: "left",
            render: (t, r) => (
                <span
                    style={{ color: '#4165E3', cursor: 'pointer' }}
                    onClick={() => {onLook(r)}}
                >
                    {t}
                </span>
        ),
        }, {
            title: '盘点部门',
            width: 180,
            dataIndex: 'departmentName',
            fixed: "left",
        }, {
            title: '盘点数量',
            width: 160,
            dataIndex: 'realTotalNum',
        }, {
            title: '库存数量',
            width: 160,
            dataIndex: 'bookTotalNum',
        }, {
            title: '差异数量',
            width: 100,
            dataIndex: 'differenceTotalNum',
        }, {
            title: '差异金额',
            width: 100,
            dataIndex: 'differenceTotalAmount',
        }, {
            title: '盘点状态',
            width: 100,
            dataIndex: 'status',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_STOCKTAKING).find((item) => item.value === text)?.label ?? '',
        }, {
            title: '盘点时间',
            width: 100,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`
        }, {
            title: '盘点结果',
            width: 100,
            dataIndex: 'result',
        }, {
            title: '盘点人',
            width: 100,
            dataIndex: 'stocktakingUser',
        }, 
    ];

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: (total: number) => `共${total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true
            }}
            bordered
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 410px)" }}
        />
    )
}
